import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {ExceptionPhotosService} from '../../services/exception-photos/exception-photos.service';
import {FlightFieldGroupService} from '../../../form-renderer/services/flight-field-group/flight-field-group.service';
import {FormUtilities} from '../../FormUtilities';
import {MdSnackBar} from '@angular/material';


@Component({
  selector: 'app-exception-photos',
  templateUrl: './exception-photos.component.html',
  styleUrls: ['./exception-photos.component.scss']
})
export class ExceptionPhotosComponent implements OnInit {

  @ViewChild('fileInput') fileInput;
  @Input() serviceId;
  imageList = [];
  showLoading = true;

  constructor(private exceptionPhotosService: ExceptionPhotosService,
              private flightFieldGroupService: FlightFieldGroupService,
              private formUtils: FormUtilities,
              private snackBar: MdSnackBar
  ) {
  }

  ngOnInit() {
    const token = '?token=' + localStorage.getItem('id_token');
    this.exceptionPhotosService.getImagesList(this.serviceId).then((results) =>
      results.map((image) => ({
        'uuid': image.uuid,
        'delete': false,
        'sync': true,
        'save': true,
        'load': true,
        'uri': image.uri + token,
      }))
    ).then((results) => {
      this.showLoading = false;
      this.imageList = results;
    })
  }

  uploadPhoto() {
    this.formUtils.chooseFile(['.png', '.jpg', '.jpeg'])
      .then(
        (fileToUpload) => this.formUtils.getBase64(fileToUpload)
          .then((result) => {
            this.imageList.push({
              'uuid': this.formUtils.createUUID(),
              'delete': false,
              'sync': false,
              'save': true,
              'load': true,
              'uri': result,
              'path': fileToUpload
            });
          }),
        () => this.snackBar.open('That file is not an image that we accept. Please upload a .png, .jpg, or .jpeg', undefined, {
          extraClasses: ['error-snackbar'],
          duration: 7000
        })
      );

  }

  clickImage(uuid) {
    const image = new Image();
    image.src = this.imageList.find((element) => element.uuid === uuid).uri;
    const w = window.open('');
    w.document.write(image.outerHTML);
  }


  deleteImage(uuid) {
    for (const image of this.imageList) {
      if (image.uuid === uuid) {
        if (image.sync)
          image.delete = true;
        else
          this.imageList.splice(this.imageList.indexOf(image), 1);
        break;
      }
    }
  }

  public get amountOfImages() {
    return this.imageList.filter(img => !img.deleted).length
  }

  /**
   * Uploads or deletes all the images as appropriate
   */
  saveChanges(): Promise<any[]> {
    const requests = [];
    for (const image of this.imageList) {
      if (image.delete) {
        requests.push(this.flightFieldGroupService.sendAction({
          type: 'DELETE_PHOTO',
          data: {
            'serviceId': this.serviceId,
            'uuid': image.uuid,
          }
        }));
      } else if (!image.sync) {
        requests.push(this.flightFieldGroupService.sendPhotoAction({
          type: 'SAVE_PHOTO',
          data: {
            'serviceId': this.serviceId,
            'uuid': image.uuid,
            'uri': image.path
          }
        }));
      }
    }
    return Promise.all(requests);
  }
}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/utilities/components/exception-photos/exception-photos.component.ts